import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from 'react-toastify';
import { saveSyllabusSubjectListSvc } from "./syllabusSubjectSvc";
import "../css/syllabusSubject.css";
import { SybSubTable } from "./SybSubTable";
import { getSyllabusSubjectListSvc } from "./syllabusSubjectSvc";

const SyllabusSubjectTable = (props) => {

    const { syllabusId, sectionId, setLoader, setOpacity } = props;
    const [tblKey, setTblKey] = useState(0)
    const [lstSubject, setLstSubject] = useState([]);

    useEffect(() => {
        // console.log("SyllabusSubjectTable called");
        // console.log("Syllabus ID:", syllabusId);
        // console.log("Section ID:", sectionId);
        getSyllabusSubjectList();
    }, [syllabusId, sectionId]);

    const getSyllabusSubjectList = () => {
        setLoader((prevLoader) => prevLoader + 1);
        setOpacity(0.5);
        getSyllabusSubjectListSvc(syllabusId, subjectListResponse);
    } 
    /* const getSyllabusSubjectList = () => {
        var lstSyllabusSubject = [{ syllabusSubjectId: 15, subjectId: 10, subject: 'English', flgExam: false, flgReportCard: false, flgScholastic: 0, flgEvaluation: 0, flgSelective: false },
        { syllabusSubjectId: 25, subjectId: 20, subject: 'Hindi', flgExam: false, flgReportCard: false, flgScholastic: 0, flgEvaluation: 0, flgSelective: false },
        { syllabusSubjectId: 35, subjectId: 30, subject: 'Maths', flgExam: false, flgReportCard: false, flgScholastic: 0, flgEvaluation: 0, flgSelective: false },
        { syllabusSubjectId: 45, subjectId: 40, subject: 'S.St.', flgExam: false, flgReportCard: false, flgScholastic: 0, flgEvaluation: 0, flgSelective: false },
        { syllabusSubjectId: 55, subjectId: 50, subject: 'Science', flgExam: false, flgReportCard: false, flgScholastic: 0, flgEvaluation: 0, flgSelective: false },
        { syllabusSubjectId: 65, subjectId: 60, subject: 'G.K.', flgExam: false, flgReportCard: false, flgScholastic: 0, flgEvaluation: 0, flgSelective: false }
        ];
        lstTmpSubject = lstSyllabusSubject;
        setLstSubject(lstSyllabusSubject);
    }; */

    const subjectListResponse = (data) => {
        // console.log("subjectListResponse called, data", data);
        let obj = data;
        if (obj.status === 'Success') {
            setLstSubject(obj.lstSubject);
            setTblKey(Math.round(Math.random()*99999))
        }
        else {
            if (obj.message == 'You are not logged in') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            }
            else if (obj.message == 'Your Session is expired, login again') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        }
        setLoader((prevLoader) => prevLoader - 1);
        setOpacity(1);
    };

    function saveSyllabusSubject(pSyllabusId, pLstSubject) {
        saveSyllabusSubjectListSvc(pSyllabusId, pLstSubject, cbSaveSybSub)
    }
    function cbSaveSybSub(data) {
        if (data.status === 'Success') {
            toast.success(data.message)
            getSyllabusSubjectList()
        } else {
            toast.error(data.message)
        }
    }
    function saveSybSubject(pSyllabusId, pLstSubject){
        pLstSubject.forEach((obj) => {
            delete obj.subjectId;
            delete obj.subject;
        })
        saveSyllabusSubject(pSyllabusId, pLstSubject)
    }
    return (
        <div className="col-sm-12 padding-remove">
            <SybSubTable key={tblKey} syllabusId={syllabusId} setTblKey={setTblKey} lstSubject={lstSubject} saveSybSubject={saveSybSubject}/>
           
        </div>
    );
}

export default SyllabusSubjectTable;


